var getMapData=require("./_getMapData");function mapCacheHas(a){return getMapData(this,a).has(a)}module.exports=mapCacheHas;